import type {
  GetFunctionsRes,
  GetFunctionsReq,
  GetFunctionDetailReq,
  GetFunctionDetailRes,
  UpdateFunctionReq,
  CreateFunctionReq,
  ImportFunctionReq,
} from 'types/functions';
import { heliosApi } from '.';
import { TAG_TYPES } from 'types/services';

export const heliosFunctionsService = heliosApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getFunctions: builder.query<GetFunctionsRes, GetFunctionsReq>({
      query: (params) => ({
        url: 'Functions',
        method: 'GET',
        params,
      }),
      providesTags: [TAG_TYPES.FUNCTIONS],
    }),
    getFunctionsDetail: builder.query<GetFunctionDetailRes, GetFunctionDetailReq>({
      query: ({ functionId }) => ({
        url: `Functions/${functionId}`,
      }),
      providesTags: [TAG_TYPES.FUNCTIONS],
    }),
    createFunction: builder.mutation<unknown, { data: CreateFunctionReq }>({
      query: ({ data }) => ({
        url: 'Functions',
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: [TAG_TYPES.FUNCTIONS],
    }),
    updateFunction: builder.mutation<unknown, UpdateFunctionReq>({
      query: (data) => ({
        url: 'Functions',
        method: 'PATCH',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: [TAG_TYPES.FUNCTIONS],
    }),
    deleteFunctions: builder.mutation<unknown, { ids: string[] }>({
      query: ({ ids }) => ({
        url: 'Functions',
        method: 'DELETE',
        params: { ids },
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: [TAG_TYPES.FUNCTIONS],
    }),
    importFunction: builder.mutation<unknown, ImportFunctionReq>({
      query: (data) => ({
        url: 'ImportFunctions',
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: [TAG_TYPES.FUNCTIONS],
    }),
  }),
});
export const {
  useGetFunctionsQuery,
  useGetFunctionsDetailQuery,
  useCreateFunctionMutation,
  useUpdateFunctionMutation,
  useDeleteFunctionsMutation,
  useImportFunctionMutation,
} = heliosFunctionsService;
